import { setBuyAnalyticsModalVisibility } from './actions';
import { IThunkActionCreator } from '../../store';

export const openBuyAnalyticsModal = (): IThunkActionCreator => {
  return (dispatch): void => {
    dispatch(setBuyAnalyticsModalVisibility(true));
  };
};
